import { FormikProps } from "formik";
import { Cell, Row } from "react-table";
import {
	FieldType,
	IFormTableSchema,
	ColumnMetadata,
	TableMetadata
} from "./types";
import { Property, PropertyTypes, propertyMessage } from "@ploy-lib/types";

export class PropertiesSchema implements IFormTableSchema<Property> {
	tableMetadata: TableMetadata<Partial<Property>> = {};

	columnMetadata: Partial<Record<keyof Property, ColumnMetadata<Property>>> = {
		refinance: {
			fieldType: FieldType.Checkbox,
			alwaysInEditMode: true
		},
		propertyInformation: {
			fieldType: FieldType.Text,
			isMultiline: true
		},
		streetName: {
			fieldType: FieldType.Text,
			displayValue: (value: any, rowData: Property) => {
				return `${rowData.streetName} ${rowData.addressNumber || ""}${
					rowData.addressLetter || ""
				}, ${padPostalCode(rowData.postalCode) || ""}, ${
					rowData.postalPlace || ""
				}`;
			}
		},
		cadastralNumber: {
			fieldType: FieldType.Text
		},
		municipalityNumber: {
			fieldType: FieldType.Text
		},
		cadastralUnitNumber: {
			fieldType: FieldType.Text
		},
		unitNumber: {
			fieldType: FieldType.Text
		},
		leaseholdUnitNumber: {
			fieldType: FieldType.Text
		},
		priority: {
			fieldType: FieldType.Number
		},
		jointDebt: {
			fieldType: FieldType.Currency,
			displayValue: (value: any, rowData: Property) => {
				const propertyType = rowData["type"] as PropertyTypes;
				return propertyType === "Share" || propertyType === "Stock"
					? value
					: "-";
			},
			isEditableFunctions: {
				HasValidType: (
					form: FormikProps<Property>,
					columnCells: Row<Property>["cells"]
				) => {
					const propertyType = form.values["type"] as PropertyTypes;
					return propertyType === "Share" || propertyType === "Stock";
				}
			}
		},
		valueEnteredByCustomer: {
			fieldType: FieldType.Currency
		},
		estimatedValue: {
			fieldType: FieldType.Currency
		},
		utilizedValue: {
			fieldType: FieldType.Currency
		},
		utilizedSecurityValue: {
			fieldType: FieldType.Currency
		},
		owners: {
			fieldType: FieldType.Multiselect
		},
		eAppraisalReference: {
			fieldType: FieldType.Text
		},
		eAppraisalDate: {
			fieldType: FieldType.Date
		},
		type: {
			fieldType: FieldType.Text,
			displayValueIntlDescriptor(value) {
				return propertyMessage[value as PropertyTypes];
			}
		}
	};
}

const padPostalCode = (postalCode: string | undefined) =>
	postalCode?.padStart(4, "0");
